/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Something_Went_WrongInputs */

const da_common_something_went_wrong = /** @type {(inputs: Common_Something_Went_WrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noget gik galt. Prøv igen senere.`)
};

/** @type {(inputs: Common_Something_Went_WrongInputs) => LocalizedString} */
const en_common_something_went_wrong = da_common_something_went_wrong;

/**

* @param {Common_Something_Went_WrongInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const common_something_went_wrong = /** @type {((inputs?: Common_Something_Went_WrongInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Something_Went_WrongInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_something_went_wrong(inputs)
	return /** @type {LocalizedString} */ ("Noget gik galt. Prøv igen senere.")
});